
  <div class="width-paginate title-card" [style.background-color]="info?.venue?.color">
      <h3 class="quicksand-bold">{{info?.accordion?.title}}</h3>
   </div>



<div class="width-paginate" >

<div class="planEstudio-div">
  <div class="izq">
    <p class="nunito-medium description">
      {{info?.accordion?.description}}
    </p>
    <ng-container *ngFor="let item of info?.accordion?.items; let i = index">
      <div #itemHeader (click)="onSelectItem(i)" [ngClass]="{ 'item-activo': selectedItemIndex === i }" class="item-estudio"
        [style.background-color]="selectedItemIndex === i ? info?.venue?.color : null">
        <span *ngIf="selectedItemIndex === i " class="mas quicksand-bold">-</span>
        <span *ngIf="selectedItemIndex !== i " class="mas quicksand-bold">+</span>
        <span class="quicksand-bold item-titulo">{{ item.title }}</span>
      </div>
      
      <div class="derecha mob" *ngIf="selectedItemIndex === i" style="margin-top: 10px;">
       <div class="content-wrapper" [class.expanded]="expanded" #contentWrapper>
          <div [innerHTML]="htmlsanitizado" class="nunito-medium bodyplan"></div>
       </div>
        <hr *ngIf="!expanded && showExpandButton && contentMaxHeight" >

       <div class="expand-container" *ngIf="showExpandButton && info?.accordion?.items.length > 0">
          <button [style.color]="info?.venue?.color" (click)="toggleExpand()" class="expand-button">
           {{ expanded ? 'ver -' : 'ver +' }}
         </button>
        </div>

      </div>
    </ng-container>
    <div class="container-btns">
        <a   *ngIf="info?.accordion?.button1Text" [href]="url(info?.accordion?.button1Url)" target="_blank" rel="noopener noreferrer">
          <button    class="btn-despegable nunito-medium zoomIn" >{{info?.accordion?.button1Text}}</button>
        </a>

        <a  *ngIf="info?.accordion?.button2Text" [href]="url(info?.accordion?.button1Url)" target="_blank" rel="noopener noreferrer">
          <button    class="btn-despegable nunito-medium zoomIn" >{{info?.accordion?.button2Text}}</button>
        </a>
    </div>
    
  </div>

  <div class="derecha desk">
    <!-- <h2 class="tituloBody nunito-bold">{{titlehtml | uppercase}}</h2> -->
    <div class="content-wrapper" [class.expanded]="expanded" [style.max-height.px]="contentMaxHeight" #contentWrapper>
      <div *ngIf="htmlsanitizado"  [innerHTML]="htmlsanitizado" class="nunito-medium bodyplan"></div>
    </div>
    <hr *ngIf="!expanded && showExpandButton" >

    <div class="expand-container" *ngIf="showExpandButton && info?.accordion?.items.length > 0">
      <button [style.color]="info?.venue?.color" (click)="toggleExpand()" class="expand-button">
        {{ expanded ? 'ver -' : 'ver +' }}
      </button>
    </div>

  </div>
</div>
</div>
